/**
 * 404-pagina – Pagina niet gevonden
 */
import { Link, useLocation } from 'react-router-dom';
import { SeoMeta } from '../components/SeoMeta';

export function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center animate-page-enter">
      <SeoMeta
        path={pathname || '/404'}
        noindex
        title="Pagina niet gevonden"
        description="Deze pagina bestaat niet op CalqTool™. Controleer de URL of ga naar home, prijzen of je dashboard — calculaties en bouwkosten blijven op de bekende routes."
      />
      <img
        src="/assets/404-lost.png"
        alt="Illustratie: verloren route — pagina niet gevonden"
        className="mb-6 max-h-48 w-auto object-contain opacity-90"
        width={320}
        height={240}
        decoding="async"
      />
      <h1 className="mb-2 text-2xl font-bold text-text">Pagina niet gevonden</h1>
      <p className="mb-6 max-w-md text-text-muted">
        De pagina die je zoekt bestaat niet of is verplaatst. Controleer de URL of gebruik een van de links hieronder.
      </p>
      <div className="flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center">
        <Link
          to="/"
          className="inline-flex rounded-lg border border-border bg-surface-card px-6 py-2.5 font-medium text-text transition hover:border-primary"
        >
          Home
        </Link>
        <Link
          to="/dashboard"
          className="rounded-lg bg-primary px-6 py-2.5 font-medium text-white transition-all duration-200 hover:scale-[1.02] hover:bg-primary-alt"
        >
          Naar dashboard
        </Link>
      </div>
      <p className="mt-8 max-w-lg text-xs leading-relaxed text-text-muted">
        <Link to="/status" className="font-medium text-primary hover:underline">
          Dienststatus
        </Link>
        {' · '}
        <Link to="/troubleshoot" className="font-medium text-primary hover:underline">
          Problemen oplossen
        </Link>
        {' · '}
        <Link to="/contact" className="font-medium text-primary hover:underline">
          Contact
        </Link>
        <span className="mx-1 text-text-muted/60">|</span>
        <Link to="/help/tekening" className="font-medium text-primary hover:underline">
          Tekening &amp; PDF
        </Link>
        {' · '}
        <Link to="/help/export" className="font-medium text-primary hover:underline">
          Export &amp; offerte
        </Link>
      </p>
    </div>
  );
}
